/**
 * Turning a blob response into a saved file.
 *
 * The sequence below — object URL, a synthetic anchor, revoke — was copied in
 * clientQuoteService and payrollService before this existed. It lives here so
 * a fix to it happens once.
 */

/** Pull the filename out of a Content-Disposition header, quoted or not. */
export const filenameFromResponse = (response) => {
  const header = response?.headers?.['content-disposition'];
  if (!header) return null;

  const match = header.match(/filename="?([^";]+)"?/);
  return match ? match[1] : null;
};

/**
 * Save an axios blob response to the user's disk.
 *
 * `fallbackName` is used when the server sent no Content-Disposition — a
 * download with no name at all saves as "download" with no extension, which
 * the operating system then cannot open.
 */
export const saveBlobResponse = (response, fallbackName) => {
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');

  link.href = url;
  link.setAttribute('download', filenameFromResponse(response) || fallbackName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
